export function crashlytics() {
  const recordError = (error: Error, jsErrorName?: string) => {};
  const log = (message: string) => {};

  return { recordError, log };
}
